import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WebCustomer } from '../../Model/WebCustomer';
import { BrandConfig } from '../../Model/Brand-Config-Interface';
import { NavigationStart, Router } from '@angular/router';
import { brandFlavor } from 'src/app/brand/brand-context';

const Env = environment;
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private webCustomerStore = new BehaviorSubject<WebCustomer>(null);
  private brandConfigStore = new BehaviorSubject<BrandConfig>(null);
  getbrandConfig$: Observable<BrandConfig> =
    this.brandConfigStore.asObservable();
  getWebcustomer$: Observable<WebCustomer> =
    this.webCustomerStore.asObservable();
  brandConfigSub: Subscription;
  brandFlavour: string;
  /**
   * The web-customer request in flight, if any. A guard redirect (a legacy
   * page to its design twin, /reservation/service-booking to /bookings, the
   * default page) fires two NavigationStarts before the first request is
   * back; without this the config was fetched twice and every subscriber
   * ran twice - Stripe mounted its card elements twice and "Pay now" hung.
   */
  private webCustomerSub: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.brandFlavour = brandFlavor();
        const webCustomer = this.webCustomerStore.getValue();
        const brandConfig = this.brandConfigStore.getValue();
        if (!webCustomer) {
          this.getWebCustomer();
        }
        if (!brandConfig) {
          this.getBrandConfig();
        }
      }
    });
  }

  private getBrandConfig(postcode = null, deliveryType = null) {
    if (this.brandConfigSub) {
      this.brandConfigSub.unsubscribe();
    }

    if (!this.brandFlavour) {
      alert(
        'Brand Flavor Missing! Please Contact Customer Support to place an order'
      );
      return;
    }

    const body = {};
    if (postcode) {
      body['Postcode'] = postcode;
    }
    if (deliveryType) {
      body['OrderOption'] = deliveryType == 'Home' ? 'Delivery' : 'Pickup';
    }

    this.brandConfigSub = this.http
      .post(Env.apiUrl + 'api/Order/v2/getConfig/' + this.brandFlavour, body)
      .pipe(shareReplay())
      .subscribe({
        next: (res: any) => {
          if (res.Info.Status == 200) {
            this.brandConfigStore.next(res['Data']);
            return;
          }
          alert(res.Info.Message);
        },
        error: (error) => {
          alert('Network Error! Please refresh page');
        },
      });
  }

  private getWebCustomer() {
    if (this.webCustomerSub && !this.webCustomerSub.closed) return; // already on its way

    if (!this.brandFlavour) {
      alert(
        'Brand Flavor Missing! Please Contact Customer Support to place an order'
      );
      return;
    }

    this.webCustomerSub = this.http
      .get(
        Env.apiUrl +
          'api/Brand/getBrandInfo/' +
          this.brandFlavour +
          '/WebCustomer'
      )
      .pipe(shareReplay())
      .subscribe({
        next: (res: any) => {
          if (res.Info.Status == 200) {
            this.webCustomerStore.next(res['Data']);
            return;
          }
          alert(res.Info.Message);
        },
        error: (error) => {
          alert('Network Error! Please refresh page');
        },
      });
  }

  /* only to update slots data in case of delivery in checkout */
  callBrandConfig(postcode: string, deliveryType: string) {
    if (!deliveryType) return;
    this.getBrandConfig(postcode, deliveryType);
  }
}
